module.exports = __webpack_public_path__ + "static/img/produto_g.2518089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tonica/produto_g.png
// module id = gy2m
// module chunks = 0